export default __webpack_public_path__ + "static/2-6-1-3-087748c5017afa22f4a3716f4734f9fd.jpg";